
import {
    Box,
    Chip
} from "@mui/material";

const FiltersBar = ({
    filters,
    onCategoryClick,
    onBranchClick,
    onCategoryTypeClick,
    children
}) => {
    console.log("FiltersBar Rendered", { filters });

    return (
        <Box
            sx={{
                display: "flex",
                gap: 2,
                flexWrap: "wrap",
                mb: 3
            }}
        >

            <Chip
                label={`Category: ${filters?.category}`}
                clickable
                // color="primary"
                style={{ color: '#002147', borderColor: '#002147', fontFamily: 'Poppins', fontWeight: 600 }}
                variant="outlined"
                onClick={onCategoryClick}
            />

            <Chip
                label={
                    filters.branch.length === 0
                        ? "Branches: All"
                        : `Branches: ${filters.branch.join(", ")}`
                }
                clickable
                // color="primary"
                style={{ color: '#002147', borderColor: '#002147', fontFamily: 'Poppins', fontWeight: 600 }}
                variant="outlined"
                onClick={onBranchClick}
            />
            <Chip
                label={`Type: ${filters?.type?.toUpperCase()}`}
                clickable
                variant="outlined"
                onClick={onCategoryTypeClick}
                sx={{
                    color: "#002147",
                    borderColor: "#002147",
                    fontFamily: "Poppins",
                    fontWeight: 600
                }}
            />

        </Box>
    );
};

export default FiltersBar;